/* global axios */
import ApiClient from './ApiClient';

class CustomersAPI extends ApiClient {
  constructor() {
    super('customers', { accountScoped: true });
  }

  get(params = {}, signal = undefined) {
    return axios.get(this.url, { params, signal });
  }

  setReferral(id, payload) {
    return axios.put(`${this.url}/${id}/referral`, payload);
  }

  preview(id, paidExpiresOn, signal) {
    return axios.post(
      `${this.url}/${id}/qualify_preview`,
      { paid_expires_on: paidExpiresOn },
      { signal }
    );
  }

  qualify(id, payload) {
    return axios.post(`${this.url}/${id}/qualify`, payload);
  }
}

export default new CustomersAPI();
